export default{
    "clinics.detail.cart.missingRequiredFields.title"    : "Informations manquantes",
    "clinics.detail.cart.missingRequiredFields.text"     : "Nous avons besoin de ces informations pour vous laisser inscrire votre membre.",
    "clinics.detail.cart.missingRequiredFields.text2"    : "Veuillez remplir les champs ci-dessous.",
    "clinics.detail.cart.missingRequiredFields.required" : "Ce champ est requis",
}